import {UseQueryResult} from '@tanstack/react-query';
import folderFetchers, {Folder} from '@/api/fetchers/content-studio/folder';
import useReactQuery from '@/hooks/use-react-query';
import {CONTENT_LAB, FOLDERS} from '../consts';

function useFoldersQuery(): UseQueryResult<Folder[], Error> {
  return useReactQuery({
    queryKey: [CONTENT_LAB, FOLDERS],
    queryFn: async (): Promise<Folder[]> => {
      const {folders} = await folderFetchers.getFolders({});
      return folders;
    },
  });
}

export default useFoldersQuery;
